// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__Response from "./response.jsx";
import * as Subsonic__Song from "./song.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.song;
  return {
    status: tmp,
    song: v$1 !== undefined ? Subsonic__Song.of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"song\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    song: Subsonic__Song.to_json(x.song)
  };
}

function response_of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function response_to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

function make(id) {
  const params = {};
  return Fx.Monad_syntax.let$star((params["id"] = {
    TAG: /* Value */ 1,
    _0: id
  }, Subsonic__Utils.makeRequest({
    _method: "rest/getSong",
    params: params
  }, response_of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.song
    };
  }));
}

export {
  body_of_json,
  body_to_json,
  response_of_json,
  response_to_json,
  make,
}
/* No side effect */
